/*global window, jQuery */
(function($) {

  'use strict';

  $(function() {

    const handleAjax = ($ajax) => $ajax
    .done((result) => {
      if (result.error) {
        shop.modalError(result.errorMessage);
        return;
      }
      location.reload();
    })
    .fail(function() {
      shop.modalError();
    });

    $('#annulla-modifica-ordine').on('click', function(){
      $.ajax({
        url: '/shop/ajax/admin-modifica-ordine.php',
        type: 'POST',
        dataType: 'json',
        data: {
              'action': 'annulla',
              'id_ordine': $(this).data('idord')
            }, 
        success: function(result){
          if (result['goto']) {
            console.log('goto');
            shop.modalSuccess(result.message, null, function(){window.location.href = result['goto'];});
            return false;
          }
          location.reload();
        }
      });
    });

    $('#modifica-ordine').on('click', function(){
      if (window.modifica == 0) {
        window.modifica = 1;
        $.ajax({
          url: '/shop/ajax/admin-modifica-ordine.php',
          type: 'POST',
          dataType: 'json',
          data: {
                'action': 'modifica',
                'id_ordine': $(this).data('idord')
              }, 
          success: function(result){
            if (result['goto']) {
              console.log('goto');
              shop.modalSuccess(result.message, null, function(){window.location.href = result['goto'];});
              return false;
            }
            location.reload();
          }
        });
      }
    });


    $('.btnArchivioInd').on('click', function(){
      shop.showAjaxModal(shop.getPopupUrl('popup-indirizzi-spedizione'), [
          {text: 'Chiudi'}
        ], {}, null);
    });


    var  updatecart = function(idprodotto, qta){
      
      $.ajax({
        url: '/shop/ajax/shop.php',
        type: 'POST',
        dataType: 'json',
        data: {
              'action': 'cart-upd',
              'id_prodotto': idprodotto, 
              'qta': qta
            }, 
        success: function(result){
          location.reload();
        }
      });
    }

    
    $('.toggle-cart-widget').on('dblclick', function(){
      window.location.href = shop.cartURL;
      return false;
    });

    $('.toggle-cart-widget').on('click', function(event){
      $('.cart-widget').toggle();

      $.ajax({url: '/shop/ajax/shop.php?action=get-cart-widget-content', success: function(result){
        $('.cart-widget-content').html(result);
      }});
      event.stopPropagation();
    });

    function delay(callback, ms) {
      var timer = 0;
      return function() {
        var context = this, args = arguments;
        clearTimeout(timer);
        timer = setTimeout(function () {
          callback.apply(context, args);
        }, ms || 0);
      };
    }


    $(document).click(function(event) { 
      var $target = $(event.target);
      if(!$target.closest('.cart-widget').length && $('.cart-widget').is(":visible")) {
        $('.cart-widget').hide();
      }        
    });

    //$('.cart-widget').mouseleave(delay(function (e) {
    //  $('.cart-widget').toggle()
    //}, 500));

    $('.qta-minus').on('click', function(){
      var elimina = false;
      var inputQta = $(this).data('qta');
      var qta = parseInt($(inputQta).val());
      var step = parseInt($(this).data('step'));
      var idprodotto = $(this).data('product');
      qta = qta - step;
      if (qta<step) {
        elimina = true;
        qta=step;
      }
      $(inputQta).val(qta);
      
      if ($(this).hasClass('update-reload')) {
        if (elimina) {
          updatecart(idprodotto, 0)
        } else {
          updatecart(idprodotto, qta)
        }
      }
    });

    $('.qta-plus').on('click', function(){
      var inputQta = $(this).data('qta');
      var qta = parseInt($(inputQta).val());
      var step = parseInt($(this).data('step'));
      var idprodotto = $(this).data('product');
      qta = qta + step;
      $(inputQta).val(qta);

      if ($(this).hasClass('update-reload')) {
        updatecart(idprodotto, qta)
      }
    });


    const emptyCartRow = function(idprodotto) {
      const message = 'Sei sicuro di voler eliminare questo prodotto dal carrello?';
      const ajaxAction = () => updatecart(idprodotto, 0);
      const buttons = [
        {text: 'Sì', action: ajaxAction, dismiss: true},
        {text: 'Annulla'}
      ];
      shop.modalConfirm(message, buttons);
    };

    $('.cart-del-row').on('click', function(){
      var idprodotto = $(this).data('product');
      emptyCartRow(idprodotto);
    });

    const salvaNote = function(data) {
      
      $.ajax({
        url: '/shop/ajax/shop.php',
          type: 'POST',
          dataType: 'json',
          data: {
                'action': 'cart-row-note',
                'note': $('#note').val(),
                'id_row': data.id_row
              }, 
          success: function(result){
            location.reload();
          }
      })

    };

    const  modifyNote = (data, callback) => {
        showAjaxModal(getPopupUrl('popup-note'), [
          {text: 'Salva Note', action: () => salvaNote(data)},
          {text: 'Chiudi'}
        ], data, callback);
      };

    $('.cart-mod-note').on('click', function(){
      var idrow = $(this).data('row');
      modifyNote({id_row: idrow}, null);
    });


    const saveCart = function(data) {
      
      $.ajax({
        url: '/shop/ajax/shop.php',
          type: 'POST',
          dataType: 'json',
          data: {
                'action': 'cart-save',
                'nome': $('#nome').val(),
                'note': $('#note').val()
              }, 
          success: function(result){
            //console.log(result)
            var message = '';
            var buttons = [];
            if (result['success']) {
              message = result['message'] || 'Il carrello è stato salvato.';
              buttons = [{text: 'Chiudi'}];
              modalSuccess(message, buttons);
            }
            if (result['error']) {
              message = result['message'] || 'Attenzione, il carrello non è stato salvato, riprovare.';
              buttons = [{text: 'Chiudi'}];
              modalError(message, buttons);
            }
          }
      })

    };

    const  salvaCarrello = (data, callback) => {
        showAjaxModal(getPopupUrl('popup-salva-carrello'), [
          {text: 'Salva Carrello', action: () => saveCart(data)},
          {text: 'Chiudi'}
        ], data, callback);
      };

    $('.cart-save').on('click', function(){
      salvaCarrello(null, null);
    });



    const emptyCart = function() {
      const message = 'Sei sicuro di voler svuotare il carrello?';
      const ajaxAction = () => handleAjax($.ajax({
        url: '/shop/ajax/shop.php',
          type: 'POST',
          dataType: 'json',
          data: {
                'action': 'cart-del'
              }, 
          success: function(result){
            location.reload();
          }
      }));
      const buttons = [
        {text: 'Sì', action: ajaxAction, dismiss: true},
        {text: 'Annulla'}
      ];
      shop.modalConfirm(message, buttons);
    };

    $('.cart-del').on('click', function(){
      emptyCart();
    });
    
    $('.add-to-cart').on('click', function(){

      var inputQta = $(this).data('qta');
      var element = $(inputQta);
      var qta = parseInt($(inputQta).val());
      var idprodotto = $(this).data('product');
      
      var qtamin = element.data('qtamin');
      var unitvendita = element.data('unitvendita');

      qta = parseInt(qta) || 0;
      qtamin = parseInt(qtamin) || 0;
      unitvendita = parseInt(unitvendita) || 0;

      
      if (parseInt(qta) < parseInt(qtamin)) {
        console.log('qta min alert');
        shop.modalError('Qta inserita non corretta; minimo acquistabile ' + unitvendita);
        return false;
      }
      if (parseInt(qta) % parseInt(unitvendita) > 0) {
        console.log('step alert');
        shop.modalError('Qta inserita non corretta; prodotto acquistabile a multipli di ' + unitvendita);
        return false;
      }

      $.ajax({
        url: '/shop/ajax/shop.php',
        type: 'POST',
        dataType: 'json',
        data: {
              'action': 'cart-add',
              'id_prodotto': idprodotto, 
              'qta': qta
            }, 
        success: function(result){
          console.log(result)
          if (result.success) {
            $('.count').html('<div>' + result.qta + '</div>');
            shop.modalSuccess('Prodotto aggiunto al carrello');
            console.log('tutto ok');
          } else {
            shop.modalError(result.message);
            console.log('prodotto senza classificazione');
          }
        }
      });



    });

    

    var confrontaAdd = (data, callback) => {
      console.log('xxx' + data);
      
      $.ajax({
        dataType: 'json',
        type: 'POST',
        url: '/shop/ajax/confronta_panel.php',
        data: {
          action: 'add',
          id_prod: data
        },
        success: function(ret) {
          $.get('/shop/ajax/confronta_panel.php?action=get', function(data) {
            $('#confronta').html(data);
          }).done(function(){
            const $modal = $('.modal');
            $modal.modal('hide');
            $.fn.matchHeight._update();
          });
        }
      });
      
      
    };

    $('body').on('click', '.add-to-compare', function() {
      var data = $(this).data('product');
      var buttons = [
        {text: 'Conferma', action: () => confrontaAdd(data)},
        {text: 'Chiudi'}
      ]
      shop.modalStandard('Aggiungo prodotto al confronta ?', buttons);
    });

    var confrontaDel = (data, callback) => {
      console.log('xxx' + data);
      
      $.ajax({
        dataType: 'json',
        type: 'POST',
        url: '/shop/ajax/confronta_panel.php',
        data: {
          action: 'del',
          id_prod: data
        },
        success: function(ret) {
          $.get('/shop/ajax/confronta_panel.php?action=get', function(data) {
            $('#confronta').html(data);
          }).done(function(){
            const $modal = $('.modal');
            $modal.modal('hide');
            $.fn.matchHeight._update();
          });
        }
      });
      
      
    };

    $('body').on('click', '.del-compare', function() {
      var data = $(this).data('product');
      var buttons = [
        {text: 'Conferma', action: () => confrontaDel(data)},
        {text: 'Chiudi'}
      ]
      shop.modalStandard('Elimino prodotto dal confronta ?', buttons);
    });


  const getModalActionButton = (button) => `<button type="button" class="btn btn-default" id="modal-action-${button.id}"> ${button.text} </button>`;

  const getModalDismissButton = (button) => `<button type="button" class="btn btn-default" data-dismiss="modal">  ${button.text} </button>`;

  const addModalButton = ($container, button) => {
    const $button = $(button.dismiss || !button.action ?
        getModalDismissButton(button) : getModalActionButton(button));
    $container.append($button);
    if (button.action) {
      $button.on('click', button.action);
    }
  };

  const modalStandard = (template, buttons) => {
    buttons = buttons || [{text: 'Chiudi'}];
    showModal(template, buttons, false);
    
  };

  const modalStandardNoButtons = (template, buttons) => {
    buttons = [];
    showModal(template, buttons, false);
    
  };

  const showModal = function(message, buttons) {
    const $modal = $('.modal');
    const $modalFooter = $modal.find('.modal-footer');

    //$('.modal-body').hide().html(message).show();
    $('.modal-body').html(message);

    if (!$modal.hasClass('in')) {
      $modal.modal('show');
    }

    $modalFooter.html('');

    if (buttons && buttons.length > 0) {
      $.each(buttons, function(index, button) {
        addModalButton($modalFooter, button);
      });
    }

    return $modal;
  };


  const rules = {
    username:{
      required: true
    },
    email: {
      required: true,
      email: true
    },
    numero_telefono: {
      required: true
    },
    password: {
      required: true,
      minlength: 6
    },
    password_check: {
      equalTo: '#password'
    },
    name: {
      required: true
    },
    lastname: {
      required: true
    },
    check_privacy: {
      required: true
    },
    check_condizioni: {
      required: true
    }
  };
  const messages = {
    username: {
      required: 'inserire il proprio username'
    },
    email: {
      required: 'inserire la mail',
      email: 'inserire una mail corretta'
    },
    password: {
      required: 'inserire la password',
      minlength: 'la password deve avere almeno {0} caratteri'
    },
    password_check: {
      equalTo: 'le password inserite non corrispondono'
    },
    name: {
      required: 'inserire il nome'
    },
    numero_telefono: {
      required: 'inserire un recapito telefonico'
    },
    lastname: {
      required: 'inserire il cognome'
    },
    check_privacy: {
      required: 'consenso sulla privacy obbligatorio'
    },
    check_condizioni: {
      required: 'consenso sulle condizioni di vendita obbligatorio'
    }
  };

  
  const $popup = $('.popup');
  const validatePopup = (submitHandler) => {
    
    const $form = $popup.find('.popup-form');
    const $errorsContainer = $popup.find('.popup-errors');
    const settings = {
      errorPlacement: (error) => {
        const $error = $(error);
        $(`#${$error.attr('id')}`).remove();
        $errorsContainer.append(error);
        if ($errorsContainer.children().length) {
          $errorsContainer.show();
        }
      },
      success: (error) => {
        const $error = $(error);
        $(`#${$error.attr('id')}`).remove();
        if (!$errorsContainer.children().length) {
          $errorsContainer.hide();
        }
      },
      messages,
      rules
    };
    if (submitHandler) {
      settings.submitHandler = submitHandler;
    }

    $form.on('submit', (event) => event.preventDefault()).validate(settings);
  };

  const showAjaxModal = (url, buttons, data, callback) => {
    data = data || {};
    if (shop.language) {
      data.language = shop.language;
    }
    $.ajax({url, data}).done((template) => {
      const $modal = showModal(template, buttons);
      if (callback) {
        callback($modal);
      }
    });
  };

  const modalError = (error, buttons, callback) => {
    if (!error) {
      error = 'Si è verificato un errore.';
    }
    buttons = buttons || [{text: 'Chiudi'}];
    showAjaxModal(`/shop/templates/popup-error.page.php?message=${error}`,
      buttons, false, callback);
  };

  const modalSuccess = (message, buttons, callback) => {
    if (!message) {
      message = 'Operazione completata con successo.';
    }
    buttons = buttons || [{text: 'Chiudi'}];
    showAjaxModal(`/shop/templates/popup-success.page.php?message=${message}`,
      buttons, false, callback);
  };

  const modalConfirm = (message, buttons) => {
    if (!message) {
      message = 'Confermi l\'operazione?';
    }
    showAjaxModal(`/shop/templates/popup-confirm.page.php?message=${message}`,
      buttons);
  };

  const modalNote = (message, buttons) => {
    
    showAjaxModal(`/shop/templates/popup-note.page.php`,
      buttons);
  };

  const addToCartSuccess = (message) => {
    console.log(shop.cartURL);
    if (!message) {
      message = 'Il prodotto è stato aggiunto al carrello.';
    }
    const buttons = [
      {
        text: 'Vai al carrello',
        action: () => window.location.href = shop.cartURL
      },
      {text: 'Continua gli acquisti',
        action: () => location.reload()}
    ];
    modalSuccess(message, buttons);
  };

  const addToCart = (products, language) => $.ajax({
    url: '/shop/ajax/cart-add-product.php',
    type: 'POST',
    dataType: 'json',
    data: {products, language}
  });

  const removeFromCart = (products, quantity, language) =>
    $.ajax({
      url: '/shop/ajax/cart-remove-product.php',
      type: 'POST',
      dataType: 'json',
      data: {products, quantity, language}
    });

  const goToCart = () => location.href = shop.cartURL;

  const addToCartModal = (products, language) => {
    addToCart(products, language).done((result) => {
      if (result.error) {
        modalError(result.errorMessage);
        return;
      }
      addToCartSuccess();
    })
    .fail(modalError);
  };

  

  const getPopupContent = (title, message, icon, type) =>
    `<div class="popup-step"><span class="glyphicon glyphicon-${icon} popup-icon popup-icon-${type}"></span><h3>${title}</h3><p>${message}</p></div>`;

  const getResultMessage = (result) => {
    const message = newsletterSetup.texts.newsletterErrors[parseInt(result)];
    if (message) {
      return message;
    }
    return newsletterSetup.texts.newsletterErrors.generic;
  };


  let signUp;
  let signIn;
  let resetPassword;
  let confirmRegistration;

  const getPopupUrl = (name) =>
    `/shop/controllers/${name}.php?language=${shop.language}`;

  const url = location.href.match(/\/$/) ?
    location.href.substring(0, location.href.length - 1) : location.href;
  const currentPage = url.match((/[^\/]+$/))[0];

  signUp = (data, callback) => {
    showAjaxModal(getPopupUrl('popup-register'), [
      {text: 'Torna alla Login', action: () => signIn(data)},
      {text: 'Chiudi'}
    ], data, callback);
  };

  resetPassword = (data, callback) => {
    showAjaxModal(getPopupUrl('popup-reset-password'), [
      /*{text: 'Registrati', action: () => signUp()},*/
      {text: 'Torna alla Login', action: () => signIn(data)},
      {text: 'Chiudi'}
    ], data, callback);
  };

  signIn = (data, callback) => {
    showAjaxModal(getPopupUrl('popup-login'), [
      {text: 'Recupera password', action: () => resetPassword(data)},
      /*{text: 'Registrati', action: () => signUp()},*/
      {text: 'Chiudi'}
    ], data, callback);
  };



  confirmRegistration = (code, data, callback) => {
    showAjaxModal(`${getPopupUrl('popup-confirm-registration')}&code=${code}`, [
      {text: 'Vai alla login', action: () => signIn(data)},
      {text: 'Chiudi'}
    ], data, callback);
  };

  const newPassword = (code, data, callback) => {
    showAjaxModal(`${getPopupUrl('popup-new-password')}&code=${code}`, [
      {text: 'Vai alla login', action: () => signIn(data)},
      {text: 'Chiudi'}
    ], data, callback);
  };

  $('.account-login').on('click', () => signIn({redirectUrl: window.shop.loginRedirectUrl}));

  

  $('.shop-buy').on('click', function() {
    const product = {
      product: $(this).data('product'),
      quantity: $(this).data('quantity') || 1,
      priceList: $(this).data('priceList')
    };
    const language = shop.language;
    addToCart([product], language)
      .done((result) => {
        if (result.error) {
          modalError();
          return;
        }
        goToCart();
      })
      .fail(modalError);
  });

  $('.shop-add-to-cart').on('click', function() {
    console.log('shop-add-to-cart');
    const product = {
      product: $(this).data('product'),
      quantity: $(this).data('quantity') || 1,
      priceList: $(this).data('priceList')
    };
    const language = shop.language;
    addToCartModal([product], language);
  });

  window.shop = window.shop || {};
  $.extend(window.shop, {
    showAjaxModal,
    validatePopup,
    confirmRegistration,
    newPassword,
    addToCartModal,
    addToCart,
    removeFromCart,
    modalStandard,
    modalStandardNoButtons,
    modalError,
    modalSuccess,
    modalConfirm,
    signIn,
    signUp,
    currentPage,
    goToCart,
    getPopupUrl
  });




  });

}(jQuery));